import request from "../utils/fetch";

// 团队列表
export function teamList(data) {
  return request({
    url: "/user/department/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 团队新增
export function teamAdd(data) {
  return request({
    url: "/user/department/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 团队编辑
export function teamEdit(data) {
  return request({
    url: "/user/department/update",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 团队删除
export function teamDel(data) {
  return request({
    url: "/user/department/update",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 团队详情
export function teamDetail(data) {
  return request({
    url: "/user/department/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 团队成员列表
export function teamStaffList(data) {
  return request({
    url: "/user/department/bind/user/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 团队添加成员
export function teamAddStaff(data) {
  return request({
    url: "/user/department/bind/user",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 团队移除成员
export function teamDelStaff(data) {
  return request({
    url: "/user/department/move/user",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 团队成员导出
export function teamExport(data) {
  return request({
    url: "/user/department/export",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 团队成员单个充值统计
export function staffTopStat(data) {
  return request({
    url: "/order/team/management/member/one/statistics",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 团队成员单个充值导出
export function staffTopStatExport(data) {
  return request({
    url: "/order/team/management/member/one/statistics/export",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 团队充值统计
export function teamStat(data) {
  return request({
    url: "/order/team/management/team/statistics/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
